export default class CreateCustomerModel {
  code?: string

  name?: string

  contacts?: string

  phoneNo?: string

  phonePrefix = '86';

  address?: string

  serviceCode?: string

  remark?: string

  accessGroupId?: string

  userAccount?:string
}
